import React, { Component } from 'react'
import { Card, Checkbox, Col, Form, Input, Select } from 'antd'
import Members from '../../../api/Members'
import { get, isEmpty } from 'lodash'

const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input

class ContactDetails extends Component {
  api = new Members()
  state = { checkedNewOrg: false, fetching: false, orgList: [], member: {} }
  async componentDidMount() {
    let member = this.props.member
    if (!isEmpty(member._key)) {
      this.setState({ fetching: true })
      let responseM = await this.api.get(member._key)
      member = await responseM.json()
    }
    this.setState({ fetching: false, member })
  }
  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { type, list, showCode } = this.props
    const { member, fetching } = this.state
    return (
      <Card style={{ marginTop: '10px' }} loading={fetching}>
        <Form layout="vertical">
          {type === 'individual' && (
            <FormItem label="Name" {...formItemLayout}>
              <Col span={3}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('n.prefix', {
                    initialValue: get(member, 'n.prefix'),
                  })(
                    <Select allowClear={true} placeholder="Prefix">
                      <Option value="mr">Mr</Option>
                      <Option value="mrs">Mrs</Option>
                      <Option value="ms">Ms</Option>
                      <Option value="miss">Miss</Option>
                      <Option value="dr">Dr</Option>
                      <Option value="prof">Prof</Option>
                      <Option value="sir">Sir</Option>
                      <Option value="datuk">Datuk</Option>
                      <Option value="datin">Datin</Option>
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col span={7}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('n.given', {
                    initialValue: get(member, 'n.given'),
                  })(<Input placeholder="Given Name" />)}
                </FormItem>
              </Col>
              <Col span={7}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('n.family', {
                    initialValue: get(member, 'n.family'),
                  })(<Input placeholder="Family Name" />)}
                </FormItem>
              </Col>
              <Col span={7}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('n.middle', {
                    initialValue: get(member, 'n.middle'),
                  })(<Input placeholder="Middle Names" />)}
                </FormItem>
              </Col>
            </FormItem>
          )}
          <FormItem label="Full Name" {...formItemLayout}>
            {getFieldDecorator('fn', {
              initialValue: get(member, 'fn'),
              rules: [
                {
                  required: true,
                  message: "Full Name can't be empty ",
                },
              ],
            })(<Input placeholder="Full Name" />)}
          </FormItem>
          {type !== 'individual' && (
            <FormItem label="Website URL" {...formItemLayout}>
              {getFieldDecorator('url', {
                initialValue: get(member, 'url'),
              })(<Input placeholder="Website URL" />)}
            </FormItem>
          )}
          {type === 'individual' && (
            <div>
              <FormItem label="Preferred Name" {...formItemLayout}>
                {getFieldDecorator('nickname', {
                  initialValue: get(member, 'nickname'),
                })(<Input placeholder="Preferred name" />)}
              </FormItem>
              <FormItem label="Position" {...formItemLayout}>
                {getFieldDecorator('position', {
                  initialValue: get(member, 'position'),
                })(<Input placeholder="Position" />)}
              </FormItem>

              {!this.state.checkedNewOrg && (
                <FormItem label="Organisation" {...formItemLayout} wrapperCol={{ sm: { span: 10 } }}>
                  {getFieldDecorator('org._id')(
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      placeholder="Select an Organisation .. ">
                      {list.map((o) => (
                        <Option value={o._id}>{o.fn}</Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
              )}
              <FormItem>
                {getFieldDecorator('org.new')(
                  <Checkbox
                    onChange={(e) => this.setState({ checkedNewOrg: e.target.checked })}
                    checked={this.state.checkedNewOrg}>
                    New{' '}
                  </Checkbox>
                )}
              </FormItem>
              {this.state.checkedNewOrg && (
                <FormItem label="New Organisation" {...formItemLayout}>
                  {getFieldDecorator('org.name')(<Input placeholder="New Organisation" />)}
                </FormItem>
              )}
            </div>
          )}
        </Form>
      </Card>
    )
  }
}

const WrappedContactDetails = Form.create()(ContactDetails)

export default WrappedContactDetails
